/* eslint-disable */
$(document).ready(function(){
	$('.uploadPhoto input[type="file"]').change(function (e) {
		var fileName = e.target.files[0].name
		$(this).parents(".uploadPhoto").addClass("active")
		$(this).parents(".uploadPhoto").find("span").html(fileName)
	})

	$('.uploadPhoto .remove').click(function () {
		$(this).parents(".uploadPhoto").find('input[type="file"]').val('')
		$(this).parents(".uploadPhoto").removeClass("active")
		$(this).parents(".uploadPhoto").find("span").html("Upload")
	})
})


